import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Loader2, ClipboardCheck, FileDown } from 'lucide-react';
import { downloadPdf } from '../../lib/download';
import { fmtDate } from '../../pages/rapports/shared';

// Bilans pédagogiques (intermédiaires / finaux) édités sur une action — portails entreprise / financeur
export const BilansActionDialog = ({ open, onClose, action, apiBase, viewAs }) => {
  const [bilans, setBilans] = useState(null);
  useEffect(() => {
    if (!open || !action) return;
    setBilans(null);
    axios.get(`${apiBase}/dossier/${action.dossier_id}/bilans`, { params: viewAs ? { view_as: viewAs } : {} }).then(r => setBilans(r.data)).catch(() => setBilans([]));
  }, [open, action, apiBase, viewAs]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="bilans-action-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ClipboardCheck className="w-5 h-5 text-cyan-600" /> Bilans pédagogiques — {action?.code}</DialogTitle>
          <p className="text-sm text-slate-500">{action?.intitule}</p>
        </DialogHeader>
        {!bilans ? <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin text-cyan-600" /></div> : bilans.length === 0 ? (
          <p className="text-sm text-slate-400 py-6 text-center" data-testid="bilans-action-vide">Aucun bilan pédagogique n'a encore été édité pour cette action.</p>
        ) : (
          <ul className="divide-y divide-slate-100 rounded-lg border border-slate-200">
            {bilans.map(b => (
              <li key={b.id} className="flex items-center justify-between gap-3 px-4 py-3" data-testid={`bilan-action-${b.id}`}>
                <div className="flex items-center gap-3 text-sm">
                  <span className={`text-[11px] px-2 py-0.5 rounded-full font-medium ${b.type === 'final' ? 'bg-indigo-100 text-indigo-700' : 'bg-sky-100 text-sky-700'}`}>{b.type === 'final' ? 'Final' : 'Intermédiaire'}</span>
                  <span className="font-medium text-slate-800">Bilan du {fmtDate(b.date_bilan)}</span>
                  {b.auteur && <span className="text-xs text-slate-400">par {b.auteur}</span>}
                </div>
                <Button type="button" size="sm" variant="outline" className="text-xs" onClick={() => downloadPdf(`${apiBase}/dossier/${action.dossier_id}/bilans/${b.id}/export-pdf`, `bilan_${b.type}_${action.code}_${b.date_bilan}.pdf`, viewAs ? { view_as: viewAs } : {})} data-testid={`bilan-action-pdf-${b.id}`}>
                  <FileDown className="w-3.5 h-3.5 mr-1" /> PDF
                </Button>
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
};
